import { AnalyticsServiceModule } from '@b2c/common/services/analytics/analytics.service';
import { HelpersServiceModule } from '@b2c/common/services/helpers/helpers.service';
import angular from 'angular';

export const RatingsDirectiveModule = angular.module('acme.common.directive.ratings', [
  AnalyticsServiceModule,
  HelpersServiceModule
])
.directive('ratings', ['AnalyticsService', 'HelpersService', function(AnalyticsService, HelpersService) {

    return {
      restrict: 'A',
      replace: false,
      templateUrl: 'common/directives/ratings/ratings.tpl.html',
      scope: {
        refAction: '&',
        starRating: '=',
        hasLink: '@',
        removeFocus: '@',
        refLink: '@',
        eventTitle: '@',
        allowRatings: '@',
        averageRating: '@'
      },

      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.ratings = {

          enabled: false,
          hasLink: false,
          refLink: false,
          refAction: false,
          removeFocus: false,
          model: -1,
          title: '',
          average: -1,
          mode: 'set',
          stars: [
            {
              rating: 1,
              decimal: 0,
              preview: false,
              set: false
            },
            {
              rating: 2,
              decimal: 0,
              preview: false,
              set: false
            },
            {
              rating: 3,
              decimal: 0,
              preview: false,
              set: false
            },
            {
              rating: 4,
              decimal: 0,
              preview: false,
              set: false
            },
            {
              rating: 5,
              decimal: 0,
              preview: false,
              set: false
            }
          ],

          init: function() {
            this.enabled = ($scope.allowRatings ===  'true');
            this.model = ($scope.starRating > 0) ? $scope.starRating : -1;
            this.title = $scope.eventTitle;
            this.average = ($scope.averageRating > 0) ? $scope.averageRating : -1;
            if ($scope.refLink) {
              // Used if stars are disabled
              this.refLink = $scope.refLink;
            }

            if ($scope.refAction) {
              // Used if stars are disabled
              this.refAction = $scope.refAction;
            }
            
            if ($scope.removeFocus) {
              // Used if stars are disabled
              this.removeFocus = $scope.removeFocus;
            }

            this.hasLink = ($scope.hasLink);

            this.update();

            $scope.$watch('averageRating', function(averageRating) {
              var self = $scope.ratings;
              self.average = (averageRating > 0) ? averageRating : -1;
              self.update();
            });
          },

          set: function(rating) {
            if (this.enabled) {
              console.log('Ratings::set', rating, typeof(this.model));

              $scope.starRating = rating;

              this.model = rating;
              this.average = this.model;
              this.mode = 'set';
              this.update();
              AnalyticsService.event({
                name: 'Ratings::Set',
                category: 'Ratings',
                label: 'Rating: ' + rating
              });
            }
          },

          get: function() {
            return this.model;
          },

          update: function() {
            var i, ii,
                averageInt,
                averageFloat;

            for (i=0,ii=this.stars.length;i<ii;i++) {
              averageInt = Math.ceil(this.average);
              averageFloat = parseFloat(this.average);

              this.stars[i].set = (i < averageInt);
              if (averageInt - 1 === i && averageFloat > i) {
                this.stars[i].decimal = averageFloat - averageInt;
              }
            }
          },

          preview: function(rating) {
            var i, ii;

            if (this.enabled) {
              this.mode = 'preview';
              console.log('Ratings::preview', rating);

              for (i=0,ii=this.stars.length;i<ii;i++) {
                this.stars[i].preview = (i < rating);
              }
            }

          },

          starClass: function(star) {

            var r = 'star-unset',
                type = (this.enabled) ? 'fa-star' : 'fa-star-o';

            if (star.set) {
              r = 'star-set';

              if (this.mode === 'set') {
                if (star.decimal !== 0) {
                  type = 'fa-star-half-o';
                }else{
                  type = 'fa-star';
                }
              }else if (this.mode === 'preview') {
                if (star.preview) {
                  r = 'star-preview-set';
                  type = 'fa-star';
                }else{
                  r = 'star-unset';
                }
              }

            }else if (star.preview) {
              r = 'star-preview';
              type = 'fa-star';
            }

            console.log('Ratings::starClass', r, type);
            r += ' ' + type;

            return r;

          },

          restore: function() {
            var i, ii;

            if (this.enabled) {
              for (i = 0, ii = this.stars.length; i < ii; i++) {
                this.stars[i].preview = false;
              }
              this.mode = 'set';
            }
          },

          onRatingMouseover: function(e) {
            var el = $(e.target);
            var rating = el.attr('id')!.split('-')[1];

            console.log('Ratings::onRatingMouseover', rating);
            $scope.ratings.preview(rating);
          },

          onRatingsClick: function(e) {
            if (!$scope.ratings.enabled) {
              if ($scope.ratings.refLink) {
                HelpersService.setHref($scope.ratings.refLink + HelpersService.addDonationParams());
              }else if (this.refAction) {
                $scope.ratings.refAction();
              }
            }
          }

        };

        $scope.ratings.init();

      }]

    };

}]).name;
